import React, { useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ContentSection } from './components/ContentSection';
import { AudienceSection } from './components/AudienceSection';
import { ActionSection } from './components/ActionSection';
import { FAQSection } from './components/FAQSection';
import { LegalModal, PrivacyContent, TermsContent } from './components/LegalModal';
export function App() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <div className="min-h-screen bg-warm-white font-sans text-warm-text selection:bg-teal/20" data-id="element-0">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-warm-gray/50 h-16 flex items-center justify-center px-4" data-id="element-1">
        <div className="max-w-6xl w-full flex justify-between items-center" data-id="element-2">
          <span className="font-bold text-navy tracking-tight" data-id="element-3">
            La Guía Bilingüe
          </span>
          <button onClick={() => document.getElementById('action')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-sm font-medium text-teal hover:text-teal-dark transition-colors" data-id="element-4">
            Obtener Reset
          </button>
        </div>
      </nav>

      <main data-id="element-5">
        <HeroSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <SolutionSection data-id="element-8" />
        <ContentSection data-id="element-9" />
        <AudienceSection data-id="element-10" />
        <ActionSection data-id="element-11" />
        <FAQSection data-id="element-12" />
      </main>

      <footer className="bg-navy text-white py-12 text-center" data-id="element-13">
        <div className="max-w-4xl mx-auto px-4" data-id="element-14">
          <p className="font-medium mb-4" data-id="element-15">
            La Guía Bilingüe © {new Date().getFullYear()}
          </p>
          <p className="text-sm text-white/60 mb-6" data-id="element-16">
            Este producto no sustituye tratamiento médico o psicológico
            profesional.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-17">
            <button onClick={() => setPrivacyOpen(true)} className="text-sm text-white/50 hover:text-teal transition-colors underline underline-offset-2" data-id="element-18">
              Política de Privacidad
            </button>
            <span className="text-white/20" data-id="element-19">|</span>
            <button onClick={() => setTermsOpen(true)} className="text-sm text-white/50 hover:text-teal transition-colors underline underline-offset-2" data-id="element-20">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-21">
        <PrivacyContent data-id="element-22" />
      </LegalModal>

      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-23">
        <TermsContent data-id="element-24" />
      </LegalModal>
    </div>;
}